/**
 * Загрузить полный профиль пользователя для отображения в модалке (фото, имя, возраст, зодиак, интересы).
 */
import { supabase } from './supabase'
import { getPhotoPublicUrl } from './profilePhotos'
import { getZodiacSign } from '../utils/zodiac'

function resolvePhotos(photos) {
  if (!Array.isArray(photos) || photos.length === 0) return []
  return photos.map((p) => (p && (p.startsWith('http') ? p : getPhotoPublicUrl(p))) || null).filter(Boolean)
}

function calculateAge(dateOfBirth) {
  if (!dateOfBirth) return null
  const today = new Date()
  const birth = new Date(dateOfBirth)
  let age = today.getFullYear() - birth.getFullYear()
  const m = today.getMonth() - birth.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--
  return age
}

function getZodiacFromDate(dateOfBirth) {
  if (!dateOfBirth) return { name: 'Unknown', symbol: '?' }
  const d = new Date(dateOfBirth)
  return getZodiacSign(d.getDate(), d.getMonth() + 1)
}

export async function loadProfileForModal(userId) {
  const { data: profile, error } = await supabase
    .from('profiles')
    .select('id, name, photos, date_of_birth, gender, interests, place_of_birth, time_of_birth')
    .eq('id', userId)
    .single()

  if (error || !profile) return null
  const photos = resolvePhotos(profile.photos || [])
  const age = calculateAge(profile.date_of_birth)
  const zodiac = getZodiacFromDate(profile.date_of_birth)
  return {
    ...profile,
    photos,
    age,
    zodiac: zodiac.name,
    zodiacSymbol: zodiac.symbol,
    interests: profile.interests || []
  }
}
